import { render, staticRenderFns } from "./ClaimYourProfileErrorModal.vue?vue&type=template&id=4439782a&scoped=true"
import script from "./ClaimYourProfileErrorModal.vue?vue&type=script&lang=js"
export * from "./ClaimYourProfileErrorModal.vue?vue&type=script&lang=js"
import style0 from "./ClaimYourProfileErrorModal.vue?vue&type=style&index=0&id=4439782a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4439782a",
  null
  
)

export default component.exports